import { trackPromise } from 'react-promise-tracker';

export async function getPDFAudit(tipo, idcampana, userToken) {

   
    return trackPromise(fetch('https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/reporting', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorizationToken': userToken
        },
        body: JSON.stringify({"tipo": tipo, "IDCampana":idcampana})
    }).then(data => data.json()))
}